import { Section } from "@app/core/match/domain/model/section";
import { StatisticsGroup } from "@app/core/statistics/domain/model/statistics-group";

export enum StatisticsStatus {
  IN_PROGRESS = "in-progress",
  OK = "ok",
}

export interface StatisticsParams {
  status: StatisticsStatus;
  group?: StatisticsGroup[];
  totalClubs?: number;
  totalMatches?: number;
  avg_victories?: number;
  stats?: Section[];
}

export class OldStatistics {
  public readonly status: StatisticsStatus;
  public readonly group: StatisticsGroup[];
  public readonly totalClubs?: number;
  public readonly totalMatches?: number;
  public readonly avg_victories?: number;
  constructor(params: StatisticsParams) {
    this.status = params.status;
    this.totalClubs = params.totalClubs;
    this.totalMatches = params.totalMatches;
    this.group = params.group!;
    this.avg_victories = params.avg_victories;
  }
}


export class Statistics {
  public readonly status: StatisticsStatus;
  public readonly totalMatches?: number;
  public readonly stats?: Section[];
  constructor(params: StatisticsParams) {
    this.status = params.status;
    this.stats = params.stats!;
    this.totalMatches = params.totalMatches;
  }
}
